<template>
    <FormMainContainer :long-content="true"
                       :title="flowTitle"
                       :previous-step-route="previousStepRoute">
        <AppointmentQuestions :selected-flow="selectedFlow"
                              @goToConfirmation="goToConfirmation" />
    </FormMainContainer>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import FormMainContainer from "~concierge/components/FormMainContainer.vue";
import HeaderSection from "~concierge/components/HeaderSection.vue";
import FooterSection from "~concierge/components/FooterSection.vue";
import AppointmentQuestions from "~concierge/components/AppointmentQuestionComponents/AppointmentQuestions.vue";
import { ConciergeAppointmentQuestionFlow } from "~types/concierge-enum";
import { router } from '@inertiajs/vue3';
import { trans } from "laravel-vue-i18n";


export default defineComponent({
    components: { HeaderSection, FooterSection, AppointmentQuestions, FormMainContainer },
    props: {
        selectedFlow: {
            type: String as PropType<ConciergeAppointmentQuestionFlow>,
            required: true,
        },
        previousStepRoute: {
            type: String,
            required: true
        },
        confirmationRoute: {
            type: String,
            required: true
        }
    },
    computed: {
        flowTitle(): string {
            switch (this.selectedFlow) {
                case 'TestDriveAppointment':
                    return trans("appointment_form_page.titles.test_drive_appointment");
                case 'FreeAppointment':
                    return trans("appointment_form_page.titles.free_appointment");
                case 'AdviserSelectionAppointment':
                    return trans("appointment_form_page.titles.adviser_selection_appointment");
                default:
                    return '';
            }
        }
    },
    methods: {
        goToConfirmation(): void {
            if (this.confirmationRoute.length > 0) {
                router.visit(this.confirmationRoute)
            }
        }
    },
});
</script>
